import { useEffect, useState } from "react"
import React from "react";
import DatePickerRange from "../PeriodSelection/DatePickerRange";
import { format } from "date-fns";
import PeriodSelectionForm from "../PeriodSelection/periodSelectionForm";
import commonServices from "../Common/commonServices";

export function ContractWizardDate(param: any) {
    const [contractStatus, setContractStatus] = useState<any>([]);
    var data;
    useEffect(() => {

        setContractStatus(param.data)

        data = {
            "contractStartDate": contractStatus.contractStartDate ? contractStatus.contractStartDate : "Enter date",
            "contractEndDate": contractStatus.contractEndDate
        }
        console.log(data)

        //    console.log(param)



    }, [param.data])



    const [StatementReports, getStatementReports] = useState<any>([]);
    useEffect(() => {
        commonServices.getreports({ isStatement: true, isReportMenu: true }).then((res) => {
            getStatementReports(res);
        });

    }, []);


    const dateSelection = (e: any) => {
        if (e !== null) {

            if (e[0] !== null) {
                console.log(format(new Date(e[0]), 'yyyyMMdd'))
            }

            if (e[1] !== null) {
                console.log(format(new Date(e[1]), 'yyyyMMdd'))
            }
        }
    }
    const dateLimitedRights = (e: any) => {

        const utcDateStr = e.toISOString();
        contractStatus.limitedRights = utcDateStr;

        setContractStatus(contractStatus);
    }

    const dateCoogan = (e: any) => {

        const utcDateStr = e.toISOString();
        contractStatus.coogan = utcDateStr;

        setContractStatus(contractStatus);
    }

    const onChange = (period: any) => {
        console.log(period);

        console.log(format(new Date(period.periodFrom.month), 'MM dd'));
        if (period.periodFrom) {
            contractStatus.reportingStartDate = Number(period.periodFrom.year + format(new Date(period.periodFrom.month), 'MMdd'));
            setContractStatus(contractStatus);
        }

        if (period.periodTo) {
            contractStatus.reportingEndDate = Number(period.periodTo.year + format(new Date(period.periodTo.month), 'MMdd'));
            setContractStatus(contractStatus);
        }

        if (period && period.action && period.action === 2) {

        }
        setContractStatus({ ...contractStatus })
        console.log(contractStatus)
    }



    const handlefieldChange = (event: any) => {

        let field_name = event.target.name; let field_value = event.target.value;
        if (field_name.includes(".")) {
            const regex = new RegExp(`\\b.\\b`, 'i');
            const match = field_name.match(regex);

            var main_obj = field_name.slice(0, match.index);
            var sub_obj = field_name.slice((match.index + 1), field_name.length);
            setContractStatus({ ...contractStatus, [main_obj]: { ...contractStatus[main_obj], [sub_obj]: field_value, } });

        } else {
            setContractStatus({ ...contractStatus, [field_name]: field_value });
        }
        console.log(contractStatus)
    }
    return (

        <div className=" box">

            <div className="box-header">  <h2>Contract Status</h2> </div>

            <div className="box-content allowVscroll" >

                <div className='ws-12 pull-left'>
                    <div className="pull-right ws-3">
                        <label className="text-left text-bold">
                            <input className="m0 mr " type="checkbox" checked={contractStatus && contractStatus.datesUnknown ? contractStatus.datesUnknown : ""} name="datesUnknown" onChange={handlefieldChange} />
                            Dates Unknown
                        </label>
                    </div>

                    <div className='ws-12'>
                        <div className='form-format ws-4'>
                            <label >Start Date *</label>
                            <div className="label-entries">
                                <DatePickerRange onChange={dateSelection} type={"single"} data={contractStatus && contractStatus.contractStartDate ? contractStatus.contractStartDate : ""} />

                            </div>

                        </div>

                        <div className='form-format ws-4'>
                            <label >End Date *</label>
                            <div className="label-entries">
                                <DatePickerRange onChange={dateSelection} type={"single"} data={contractStatus && contractStatus.contractEndDate ? contractStatus.contractEndDate : ""} />

                            </div>

                        </div>

                        <div className='pull-right mtl ws-3'>
                            <label className="text-left text-bold pull-left mtl">
                                <input className="m0 mr" type="checkbox" checked={contractStatus && contractStatus.payOutUnRecouped ? contractStatus.payOutUnRecouped : ""} name="payOutUnRecouped" onChange={handlefieldChange} />
                                In Perpetuity
                            </label>

                        </div>

                    </div>

                    <div className='form-format  ws-12'>
                        <label >Signature Date *</label>
                        <div className="label-entries w-30">
                            <DatePickerRange onChange={dateSelection} type={"single"} data={"Wed Oct 11 2022 00:00:00 GMT+0400"} />

                        </div>

                    </div>

                    <div className='ws-12'>
                        <div className='form-format ws-4'>
                            <label className="text-bold ws-12 forceSingleLine pr">Reporting Start Date *</label>
                            <div className="label-entries">
                                <input className="ws-11" disabled={true} value={contractStatus && contractStatus.reportingStartDate ? contractStatus.reportingEndDate : "Wed Oct 11 2022 00:00:00 GMT+0400"} onChange={handlefieldChange} />
                            </div>

                        </div>

                        <div className='form-format ws-4'>
                            <label className="ws-12 text-bold forceSingleLine">Reporting End Date *</label>
                            <div className="label-entries">
                                <input className="ws-11" disabled={true} value={contractStatus && contractStatus.reportingEndDate ? contractStatus.reportingEndDate : "Wed Oct 11 2022 00:00:00 GMT+0400"} onChange={handlefieldChange} />
                            </div>

                        </div>


                        <div className='form-format ws-3 ptxl mtl'>
                            <input className="m0 mr" type="checkbox" checked={contractStatus && contractStatus.noEndDate ? contractStatus.noEndDate : "Wed Oct 11 2022 00:00:00 GMT+0400"} onChange={handlefieldChange} />
                            <label className="text-left text-bold ws-12">  No End Date</label>
                        </div>

                    </div>

                    <div className="form-format">
                        <label  >Reporting*</label>
                        <div className="label-entries">
                            <select className="full-height ws-12" name="reporting" onChange={handlefieldChange}>
                                <option value="0" label="Monthly">Monthly</option>
                                <option value="1" label="Quarterly">Quarterly</option>
                                <option value="2" label="Bi-Annually">Bi-Annually</option>
                                <option value="3" label="Annually">Annually</option>
                            </select>

                        </div>
                    </div>

                    <div className="form-format">
                        <label >Statement</label>
                        <div className="12">
                            {
                                StatementReports.map((value: any) => {

                                    return <>
                                        <div className="box-primary ms text-center iconReport pull-left"  >
                                            <i className="box icon-reporting1" ng-class="{ 'active': reports.reportId === contractDetails.defaultStatement }" />
                                            <span className="ws-12 mt">{value.name}</span>
                                        </div>
                                    </>
                                })
                            }
                            <select className="full-height ws-12 hide" name="Statement" onChange={handlefieldChange}>
                                <option value="0" label="101 - Quarterly Account Summary">101 - Quarterly Account Summary</option>
                                <option value="1" label="102 - Detail Statements">102 - Detail Statements</option>
                                <option value="2" label="401 - Mechanical Royalties">401 - Mechanical Royalties</option>
                                <option value="3" label="114 - Biannual Profit Statement">114 - Biannual Profit Statement</option>
                                <option value="4" label="112 - Bi-Annual Statement">112 - Bi-Annual Statement</option>
                                <option value="5" label="111 - Bi-Annual Account Summary">111 - Bi-Annual Account Summary</option>
                                <option value="6" label="602 - 602 Standard Publishing Statement">602 - 602 Standard Publishing Statement</option>
                                <option value="7" label="400 - Mech Summary">400 - Mech Summary</option>
                                <option value="8" label="410 - Mech Biannual Summary">410 - Mech Biannual Summary</option>
                            </select>
                        </div>
                    </div>

                    <div className="ws-6 form-format">
                        <label >Coogan</label>
                        <div className="label-entries">
                            <DatePickerRange onChange={dateCoogan} type={"single"} data={"Wed Oct 11 2022 00:00:00 GMT+0400"} />
                            <input className="hide" name="Coogan" onChange={handlefieldChange}></input>
                        </div>
                    </div>

                    <div className="ws-6 form-format">
                        <label >Limited Rights</label>
                        <div className="label-entries">
                            <DatePickerRange onChange={dateLimitedRights} type={"single"} data={"Wed Oct 11 2022 00:00:00 GMT+0400"} />
                            <input className="btn-grey hide" type="date" disabled={true} name="Coogan" onChange={handlefieldChange}></input>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}
